import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Los-Angeles.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Achieve Your Digital Success with a Professional Software Company
              in Los Angeles
            </h2>
            <p>
              We specialize in bespoke software development, driven by the most
              recent advancements obtained via rigorous integrations and unique
              feature adaptations. Our top software developers in LA adhere to
              the highest coding standards, supported by a dedicated team that
              provides post-sales support and maintenance.
            </p>
            <p>
              Being a top-rated Software company in Los Angeles, we empower
              businesses toward success through digital empowerment and
              proactive consulting. We firmly believe in the potential of
              digital transformation to set businesses apart in the competitive
              market.
            </p>
            <p>
              So, start your software development journey with us right away by
              engaging with our consultants. Let's establish a route to digital
              success that transforms industries and distinguishes your brand.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
